import Block from "components/layout/Block";

export function Condition({ value, children }) {
	return value ? children : null;
}

export function ConditionBlock({ value, children, ...props }) {
	return value ? <Block {...props}>{children}</Block> : null;
}